import Color from 'color';
import { darken, lighten } from 'polished';

/** vromo corporate color schema */
const theme = {
    /** orange */
    primary: '#FFB02E',
    /** green */
    secondary: '#6FAD83',
    /** purple */
    tertiary: '#8779BD',
    /** white */
    background: '#fff',
    /** grey */
    container: '#d8d8d8',

    /** green */
    success: '#6FAD83',
    /** soft red */
    danger: '#FF4A4A',
    /** vromo orange */
    warn: '#FFB02E',
    /** very light yellow */
    oof: '#FFEE80',

    /** super light Grey*/
    offWhite: '#fcfcfc',
    /**  light++ Grey */
    ultraLightGrey: '#f5f5f5',
    /**  light Grey*/
    lightGrey: '#eee',
    grey: '#cccccc',
    /** strong grey */
    mediumGrey: '#737373',
    /** almost black grey */
    darkGrey: '#10100E',

    text: {
        light: '#f6f6f6',
        dark: '#474747',

        color(color: string): string {
            return Color(color).isLight() ? this.dark : this.light;
        },
        muted(color: string): string {
            return Color(color).isLight() ? lighten(0.1, this.dark) : darken(0.1, this.light);
        }
    }
};

export default theme;
